export const insideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/rP7PEgdRvaGMa2W2hjQwoB/Captura_de_pantalla_2026-09-30_000235.png',
    alt: 'Inside page: Common errors & fast corrections',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bGEywusB8SybMjtMfTpTrx/Captura_de_pantalla_2026-09-30_000207.png',
    alt: 'Inside page: Barre circuit guide + round tracker',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/d7eE7GACHLzM7tWEanZDGe/Captura_de_pantalla_2026-09-30_000143.png',
    alt: 'Inside page: Support scale + balance check',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/7vjiKkPRVJbYaFMCkfBtpr/Captura_de_pantalla_2026-09-30_000113.png',
    alt: 'Inside page: Ball placement + squeeze sequence',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cesAfdXQ1jwCwPKrki6r9w/Captura_de_pantalla_2026-09-30_000054.png',
    alt: 'Inside page: Glute press sequence',
  },
]
